import { Icon, IconNameType } from "@/lib/main";
import { CSSProperties } from "react";

type Props = {
  name: IconNameType;
  disabled?: boolean;
  onClick?: () => void;
  end?: boolean;
};

export default function PlaceholderIcon({
  name,
  disabled,
  onClick,
  end,
}: Props) {
  const placeholderIconStyle: CSSProperties = {
    position: "absolute",
    top: end ? "0" : "var(--spacing-md)",

    insetInlineStart: end ? "auto" : "var(--spacing-md)",
    insetInlineEnd: end ? "0" : "auto",
    padding: end ? "var(--spacing-md)" : "0",
  };

  return (
    <div
      className={end ? "cursor-pointer" : undefined}
      onClick={onClick && onClick}
      style={placeholderIconStyle}
    >
      <Icon name={name} color={disabled ? "disabled" : "tertiary"} size="lg" />
    </div>
  );
}
